import * as React from 'react';
import classes from './Auth.module.scss';
import { WithChildren } from '../../models/children-props';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { invitationDetailsVar } from '../../providers/AppProvider';

export type AuthViewProps = WithChildren<{
  //
  footer?: AuthFooterEnum;
}>;

export enum AuthFooterEnum {
  login = 1,
  backToLogin,
  signup,
  home
}

export const AuthView = (props: AuthViewProps): JSX.Element => {
  const invitation = useReactiveVar(invitationDetailsVar);
  const rootClasses = classNames(classes.Auth, 'grid-x', 'align-justify');
  const leftColumn = classNames('cell', 'small-shrink', 'large-5', 'large-order-1', classes.LeftColumn);
  const rightColumn = classNames('cell', 'small-auto', 'large-7', 'large-order-2', 'full-height', classes.RightColumn);
  const footerClass = classNames('cell', 'shrink', classes.Footer);
  let footerElem: JSX.Element | null;

  switch (props.footer) {
    // TODO: Remove the comment later on the test too
    // case AuthFooterEnum.login:
    //   if (!isFromChromeExtension) {
    //     footerElem = (
    //       <>
    //         Don&apos;t have an account? <br className={'show-for-small-only'} />
    //         <Link to={'/signup'}>Sign Up</Link>
    //       </>
    //     );
    //   } else {
    //     footerElem = null;
    //   }
    //   break;
    case AuthFooterEnum.backToLogin:
      footerElem = (
        <>
          Back to{' '}
          <Link reloadDocument to={'/login'}>
            {/* TODO remove reloadDocument once React app is the only app - we need reloadDocument to load legacy login portal.*/}
            Log In
          </Link>
        </>
      );
      break;
    case AuthFooterEnum.signup:
      footerElem = (
        <>
          Already have an account? <br className={'show-for-small-only'} />
          <Link
            reloadDocument
            to={'/login'}
            onClick={() => {
              /* TODO remove reloadDocument and this session storage once React app is the only app - this is for the legacy login portal. */
              if (invitation) {
                sessionStorage.setItem('invitation', JSON.stringify(invitation));
              }
            }}>
            Log In
          </Link>
        </>
      );
      break;
    case AuthFooterEnum.home:
      footerElem = (
        <>
          Back to <Link to={'/'}>SmarterQueue</Link> homepage
        </>
      );
      break;
    default:
      footerElem = null;
  }

  const footer: JSX.Element | null = footerElem ? (
    <div className={footerClass}>
      <div className={'grid-x grid-padding-x'}>
        <div className={'cell small-10 small-offset-1 medium-6 medium-offset-3 large-10 large-offset-1'}>
          <div className={'light-grey-text'}>{footerElem}</div>
        </div>
      </div>
    </div>
  ) : null;

  return (
    <div className={rootClasses}>
      <div className={rightColumn}>
        <div className={'grid-x align-middle full-height'}>
          <div className={'cell expanded'}>
            <span className={'show-for-sr'}>Right column</span>
          </div>
        </div>
      </div>
      <div className={leftColumn}>
        <div className={'grid-y align-justify full-height'}>
          <div className={'cell auto'}>
            <div className={'grid-x grid-padding-x full-height align-middle'}>
              <div
                className={
                  'cell small-10 small-offset-1 medium-6 medium-offset-3 large-10 large-offset-1 xlarge-8 xlarge-offset-2'
                }>
                {props.children}
              </div>
            </div>
          </div>
          {footer}
        </div>
      </div>
    </div>
  );
};
